import { Image } from 'antd';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';

const SkillsetInsight = () => {
  return (
    <Page header={<ActionHeader title="Skillset Reserve (Coming soon)" />}>
      <div style={{ padding: 24 }}>
        <Image
          src="/skillset_insight.png"
          preview={false}
          style={{ width: '100%' }}
        ></Image>
      </div>
    </Page>
  );
};

export default SkillsetInsight;
